import React, { Component, Fragment, PureComponent } from 'react';
import { NavLink, Link, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { numberFormat } from '../../common';
import Modal from '../modal';
import logo from '../../assets/img/logo.png';
import LoginForm from '../loginForm/'
import LogoutTimer from '../logoutTimer';
import ChangePassModal from '../account/changePassModal';
import onClickOutside from "react-onclickoutside";

@withRouter
@inject('appStore', 'accountStore')
@observer
class Balance extends Component{

	timer = null;

	componentDidMount() {
		this.props.accountStore.getBalance();
		this.timer = setInterval(() => {
			this.props.accountStore.getBalance();
		}, 6000);
	}

	render() {
		const {balance, accountSettings} = this.props.accountStore;
		const {name} = this.props.appStore.currency;
		return(
			<Fragment>
				<span className="icon-card f-s-ico-balanse"/>
				<span className="header-account-menu__balance ">
				    <b className="">{accountSettings.showHeaderBalance ? `${numberFormat(balance,  2, ',', ' ')} ${name}`: '***'}</b>
				</span>
			</Fragment>
		)
	}
}

@withRouter
@inject('accountStore', 'appStore', 'routingStore')
@observer
export default class Header extends Component {

	constructor(props) {
		super(props);
		this.state = {
			forgout_pass_modal_show: false,
			moreItems: false
		}
	}

	toggleLoginModal = () => {
		this.props.accountStore.toggleLoginForm();
	}

	togglePassModal = () => {
		this.setState({forgout_pass_modal_show: !this.state.forgout_pass_modal_show ? true : false});
	}

	logout = () => {
		this.props.accountStore.logout();
	}

	hideBalance = () =>{
		this.props.accountStore.hideBalance();
	}

	showMore = () =>{
		this.setState({moreItems: !this.state.moreItems})
	}

	componentDidMount() {
		this.props.appStore.setHistory(this.props.history);

		if (typeof window.btOnRoute === 'function') {
			window.btOnRoute = window.btOnRoute;
		} else {
			window.btOnRoute = route => route;
 		}

		if (typeof window.btGoTo === 'function') {
			window.btGoTo = window.btGoTo;
		} else {
			window.btGoTo = (route) => {
	   		this.props.history.push(route);
	   	};
 		}

		window.BT = {
			goTo: (route) => {
	   		this.props.history.push(route);
	   	},
	   	onRoute: (route) => {
	   		return route;
	   	}
		};

		window.btOnRoute(this.props.location.pathname);

		// TODO удалить после выкладки на прод новой оболочки

		if (window.__BTApp) {
			window.BT.onRoute = window.__BTApp.onRoute;
		}	else {
			window.BT.onRoute = () => {};
		};

   	window.BT.onRoute(this.props.location.pathname);
  }

  componentDidUpdate() {
  	if (typeof window.BT.onRoute === 'function') window.BT.onRoute(this.props.location.pathname);
  	if (typeof window.btOnRoute === 'function') window.btOnRoute(this.props.location.pathname);
  }

	render() {
		const {terminalAccess, links, showTopMenu, cashboxMode, currency_id } = this.props.appStore;
		const { access, showLoginForm, autoLogout, isCard, changePsw, showChangePass, getHideRoutes, countBets } = this.props.accountStore;
		const { showHeaderBalance } = this.props.accountStore.accountSettings;
		const { pathname } = this.props.location;

		return (
			<header className="header" >
        <div>
          { terminalAccess? <Link to="/" className="header__logo"></Link> : <span to="/" className="header__logo"></span> }
        </div>
        <div className="header__block">
        {showTopMenu && terminalAccess?
        	<div className="header__top">
        		<div className="header-counts">
              <Link  className={`header-counts__item ${pathname === '/line' ? 'active_item' : ''}`} to="/line" >
                  Линия
              </Link>
              <Link  className={`header-counts__item ${pathname === '/live' ? 'active_item' : ''}`}  to="/live" >
                  Live
              </Link>
							<Link  className={`header-counts__item ${pathname === '/results' ? 'active_item' : ''} results`}  to="/results" >
								Результаты
							</Link>
					{
						currency_id === 2 ?
							<Link  className={`header-counts__item ${pathname === '/toto' ? 'active_item' : ''}`}  to="/toto">
								{cashboxMode === 2 ? 'Cуперэкспресс' : 'Zenit-тото'}
							</Link>
							: ''
					}

		          <Link  className={`header-counts__item ${pathname === '/stats' ? 'active_item' : ''}`}  to="/stats">
                Статистика
            	</Link>
            	{cashboxMode == 2 ?
            	<Link  className={`header-counts__item header-counts__item_rules ${pathname === '/rules' ? 'active_item' : ''}`} to="/rules">
	                Правила
            	</Link>
            	: '' }
            	<div className="header-more header-drop" onClick={this.showMore}>
								<span>ЕЩЕ <div style={{position:'absolute',right:'0'}}><span className="f-s-ico-arrow_buttom_1"/></div></span>
								{
									this.state.moreItems ?
										<div className="header-drop__sub">
											<span className="header-drop__sub-arrow" />
											<Link  className={`header-drop__item`} to="/line" >
												Линия
											</Link>
											<Link  className={`header-drop__item`}  to="/live" >
												Live
											</Link>
											<Link  className={`header-drop__item results`}  to="/results" >
												Результаты
											</Link>
											{
												currency_id === 2 ?
													<Link  className={`header-drop__item `}  to="/toto">
														{cashboxMode === 2 ? 'Суперэкспресс' : 'Zenit-тото'}
													</Link>
													: ''
											}

											<Link  className={`header-drop__item `}  to="/stats">
												Статистика
											</Link>
											{
												!getHideRoutes.includes('rules') || cashboxMode == 2 ?
													<Link
														className={`header-drop__item`}
														to="/rules">
														Правила
													</Link> : ''
											}
										</div>
										:
										null
								}
							</div>

            </div>
	        	{	terminalAccess?
	        			access ?
			          	<div className="header-account-menu clearfix">
			          		<Balance />
										<span className={ !!showHeaderBalance ? 'show-balance' : 'hide-balance'} onClick={this.hideBalance}/>
								    {/*<a href="#" className="header-login__btn login__btn_perlen open-deposit-js">Пополнить</a>*/}
								    { !getHideRoutes.includes('bets') ?
										<Fragment>
											<NavLink to="/account/bets" className="header-counts__item-bets" >
												<span>Ставки</span>
												{
													countBets ? <span className="bets-counter">{countBets}</span> : null
												}
											</NavLink>
										</Fragment>
								  	: null }

								    <Account hideRoutes={getHideRoutes} />
								    { !isCard ?
								    	<Fragment>
			                	<a href="#" className="header-counts__item--logout" onClick={this.logout}>
			                    Выход
			                    { autoLogout && autoLogout.timerVisible.status ? <span> {autoLogout.timerVisible.html} </span> : ''}
			                	</a>
			                	<LogoutTimer />
		                	</Fragment>
		                : ''}
		              </div>
								:
								<div className="header-login">
							    <div className="header-login__grp">
							    	<button href="#" target="_parent" className="header-login-registration" onClick={this.togglePassModal}>Забыли пароль?</button>
							    	<button className="header-login__btn_sign" tabIndex="3" onClick={this.toggleLoginModal}>Войти по номеру телефона</button>
							    </div>
								</div>
						: null
					}
	          { terminalAccess&& !access && showLoginForm ?
	            	<LoginForm show={showLoginForm} onCloseModal={this.toggleLoginModal} />
	          : null }
	          { terminalAccess&& !access && this.state.forgout_pass_modal_show ?
	          	<Modal styleModal={{width: '300px'}} show={this.state.forgout_pass_modal_show} onCloseModal={this.togglePassModal} >
	          		<div className="forgout_pass_message">
	          			<div className="forgout_pass__icon f-s-ico-info"></div>
	          				Для восстановления пароля обратитесь к кассиру
	          		</div>
	          	</Modal>
	          : null }
          </div>
          : '' }
      	</div>
        { showChangePass ?
        	<Modal styleModal={{width: '700px'}} show={changePsw} fixed={1} title="СМЕНА ПАРОЛЯ">
        		<ChangePassModal />
        	</Modal>
        : null }
			</header>
		);
	}
}

@onClickOutside
class Account extends Component{

	state = {
		showDrop: false,
	}

	toogleDrop = () =>{
		this.setState({showDrop: !this.state.showDrop});
	}

	handleClickOutside(evt) {
		this.setState({showDrop: false});
	}

	render() {

		const {hideRoutes} = this.props;

		return(
			<div className={`account-dropdown-menu header-drop dropdown`} onClick={this.toogleDrop}>
        <span>Счет <div><span className="f-s-ico-arrow_buttom_1"></span></div></span>
        <div className={`header-drop__sub dropdowns${this.state.showDrop ? '' : ' hidden'}`}>
					<span className="header-drop__sub-arrow" />

            <Link className="header-drop__item" to="/account">
               Ваши данные
            </Link>

          {!hideRoutes.includes('history') ?
	            <Link className="header-drop__item" to="/account/history">
	               История счета
	            </Link>
          : ''}
          {!hideRoutes.includes('payout') ?

	            <Link className="header-drop__item" to="/payout">
	               Выплата
	            </Link>
        	: ''}
        </div>
      </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/header/index.jsx